import axios from "../../axios";

import * as apis from "../../apis";
import * as errors from "../../errors";
import * as successes from "../../successes";

import {sendAction} from "../../helpers";

import {notifyError, notifySuccess} from "../../toast-notifications";


// GET SURVEYS
export const GET_DEFAULT_SURVEY_REQUEST = "GET_DEFAULT_SURVEY_REQUEST";
export const GET_DEFAULT_SURVEY_SUCCESS = "GET_DEFAULT_SURVEY_SUCCESS";
export const GET_DEFAULT_SURVEY_ERROR = "GET_DEFAULT_SURVEY_ERROR";

export const getDefaultSurvey = () => {
    return dispatch => {
        dispatch(sendAction(GET_DEFAULT_SURVEY_REQUEST));
        axios.get(apis.GET_SURVEYS_API)
            .then(({data}) => {
                dispatch(sendAction(GET_DEFAULT_SURVEY_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_DEFAULT_SURVEY_ERROR, {error}));
                notifyError(errors.GET_DEFAULT_SURVEY_ERROR);
            });
    }
};

// ANSWER SURVEYS
export const ANSWER_SURVEY_REQUEST = "ANSWER_SURVEYS_REQUEST";
export const ANSWER_SURVEY_SUCCESS = "ANSWER_SURVEYS_SUCCESS";
export const ANSWER_SURVEY_ERROR = "ANSWER_SURVEYS_ERROR";

export const answerSurvey = (data) => {
    return dispatch => {
        dispatch(sendAction(ANSWER_SURVEY_REQUEST));
        axios.post(apis.ANSWER_BARESTHO_SURVEY_API, data)
            .then(() => {
                dispatch(sendAction(ANSWER_SURVEY_SUCCESS));
                notifySuccess(successes.ANSWER_SURVEY_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(ANSWER_SURVEY_ERROR));
                notifyError(errors.ANSWER_SURVEY_ERROR);
            });
    }
};


export const GET_SURVEYS_STATUS_REQUEST = "GET_SURVEYS_STATUS_REQUEST"
export const GET_SURVEYS_STATUS_SUCCESS = "GET_SURVEYS_STATUS_SUCCESS"
export const GET_SURVEYS_STATUS_ERROR = "GET_SURVEYS_STATUS_ERROR"

export const getSurveysStatus = (last_name, token) => {
    return dispatch => {
        dispatch(sendAction(GET_SURVEYS_STATUS_REQUEST));
        axios.post(apis.GET_SURVEYS_STATUS_API, {last_name, token})
            .then(({data}) => {
                dispatch(sendAction(GET_SURVEYS_STATUS_SUCCESS, {data}));
            })
            .catch((error) => {
                dispatch(sendAction(GET_SURVEYS_STATUS_ERROR, {error: error.response.data.message}));
            });
    }
}

export const RESERVATION_NOT_PASSED = "RESERVATION_NOT_PASSED";
export const RESERVATION_NOT_ELIGIBLE = "RESERVATION_NOT_ELIGIBLE";


// WEBPACK FOOTER //
// ./src/store/actions/feedbacks.js